import React from 'react'
import Navbar from '../Navbar/Navbar'
import { Outlet } from 'react-router-dom'
import Footer from '../Footer/Footer'

export default function Layout({userData, setUserData, setIsLogged, isLogged}) {
  console.log(isLogged);
  return (
    <div style={{display:"flex",flexDirection:"column",justifyContent:"space-between"}}>
    <Navbar userData={userData} setUserData={setUserData} isLogged={isLogged} setIsLogged={setIsLogged}/>
    <main  style={{minHeight:"70vh"}}>
    <div className="container" >
      <Outlet userData={userData} />
    </div>
    </main>
    <Footer/>
    </div>
  )
}
